export type ApiResponse<T> = {
    Success?: boolean,
    Error?: string,
} & T;

export type BaseFeaturesModel = {
    MFA_Active: boolean,
    JobBoard_Speculatives: boolean,
    CompanyPrivacyPolicyText: string,
    PrivacyPolicyText: string,
    PrivacyUrl: string,
    PrivacyPolicyFeature: boolean,
    IsIntranetDisplay: boolean, // is it possible for the user to access the intranet
    SupplementaryInformationText: string,
    CarouselOrders: number[],
    SupplementaryInformationFeature: boolean,
    JobAlerts: boolean,
    AdminEmailAddress: string,
    UseEmailVerification: boolean,
}

export async function postData<TModel>(path: string, data?: any): Promise<TModel> {
    if (!path || !path.length) {
        path = '/';
    }
    if (!path.startsWith('/')) {
        path = `/${path}`;
    }

    const tokens: NodeListOf<HTMLInputElement> = document.getElementsByName('__RequestVerificationToken') as any;
    const token = tokens && tokens.length ? tokens[0].value : '';

    const res = await fetch(`${window.location.origin}${path}`, {
        method: "POST",
        credentials: "same-origin",
        headers: {
            'Accepts': 'application/json',
            '__RequestVerificationToken': token,
        },
        body: data,
    });

    if (await API_AuthAndRedirectChecker(res))
        return new Promise((x, y) => { }); //Wait for page load

    if (res.ok) {
        const data = await res.json() as TModel;
        return data;
    } else {
        throw res;
    }
}

export async function getData<TModel>(path: string): Promise<TModel> {
    if (!path || !path.length) {
        path = '/';
    }
    if (!path.startsWith('/')) {
        path = `/${path}`;
    }

    const tokens: NodeListOf<HTMLInputElement> = document.getElementsByName('__RequestVerificationToken') as any;
    const token = tokens && tokens.length ? tokens[0].value : '';

    const res = await fetch(`${window.location.origin}${path}`, {
        method: "GET",
        credentials: "same-origin",
        headers: {
            'Accepts': 'application/json',
            '__RequestVerificationToken': token,
        },
    });

    if (await API_AuthAndRedirectChecker(res))
        return new Promise((x, y) => { }); //Wait for page load

    if (res.ok) {
        const data = await res.json() as TModel;
        return data;
    } else {
        throw res;
    }
}

export async function postJson<TModel>(path: string, data?: any): Promise<TModel> {
    if (!path || !path.length) {
        path = '/';
    }
    if (!path.startsWith('/')) {
        path = `/${path}`;
    }
    const tokens: NodeListOf<HTMLInputElement> = document.getElementsByName('__RequestVerificationToken') as any;
    const token = tokens && tokens.length ? tokens[0].value : '';
    const res = await fetch(`${window.location.origin}${path}`, {
        method: "POST",
        credentials: "same-origin",
        headers: {
            'Content-Type': 'application/json',
            'Accepts': '*/*',
            '__RequestVerificationToken': token,

        },
        body: data ? JSON.stringify(data) : undefined,
    });

    if (await API_AuthAndRedirectChecker(res))
        return new Promise((x, y) => { }); //Wait for page load

    if (res.ok) {
        const data = await res.json() as TModel;
        return data;
    } else {
        throw res;
    }
}

export async function API_GetFeatures(intranetToken : string) {
    const tokens: NodeListOf<HTMLInputElement> = document.getElementsByName('__RequestVerificationToken') as any;
    const token = tokens && tokens.length ? tokens[0].value : '';
    var response = await fetch(`${window.location.origin}/webapi/candidate/system/Features?token=${intranetToken}`, {
        method: "GET",
        credentials: "same-origin",
        headers: {
            'Accepts': 'application/json',
            '__RequestVerificationToken': token,
        }
    });
    if (response.ok) {
        return await response.json() as ApiResponse<BaseFeaturesModel>;
    }
}

export async function API_AuthAndRedirectChecker(response: Response) {
    if (!response.ok && response.status == 403) {
        var ll = response.headers.get("a4lloginlocation");
        if (ll != null)
            window.location.replace(`${ll}`);
        else
            window.location.replace(`${window.location.origin}/app`);

        return true;
    }

    if (response.ok && response.redirected && response.url != null && response.url != '') {
        if(response.url.startsWith("/"))
            window.location.replace(`${window.location.origin}/${response.url}`);
        else
            window.location.replace(`${response.url}`);

        return true;
    }
    return false;
}